import { find, propEq } from 'ramda';
import React, { FC } from 'react';

import FlexColumn from '@ui/atoms/FlexColumn';
import HeadingText from '@ui/atoms/HeadingText';
import TextLink from '@ui/atoms/TextLink';
import WYSIWYGContent from '@ui/atoms/WYSIWYGContent';

import CenteredGridItem from '@ui/molecules/CenteredGridItem';

import { MemberInfo } from '@hooks/useMemberInfo';

import { getStateName } from '@utils/intake/stateRequirements';

import { IFlowStepComponentProps } from '@folx-types/flow-steps';

interface IStateRestrictionContent {
	stateName: string;
	pageHeader: string;
	pageInfo: string;
	learnMoreHref: string;
	showLearnMore: boolean;
}

export interface IStateRestrictionStepPageContent {
	stateRestrictions: IStateRestrictionContent[];
	learnMoreText: string;
}

interface IStateRestrictionStepProps extends IFlowStepComponentProps {
	pageContent: IStateRestrictionStepPageContent;
	memberInfo?: MemberInfo;
}

const StateRestrictionStep: FC<IStateRestrictionStepProps> = ({ pageContent, memberInfo }) => {
	const { stateRestrictions, learnMoreText } = pageContent;

	const stateRestriction = find(
		propEq('stateName', getStateName(memberInfo?.stateOfResidence?.abbreviation ?? '')),
		stateRestrictions
	) ?? {
		pageHeader: '',
		pageInfo: '',
		learnMoreHref: '',
		showLearnMore: false,
	};

	return (
		<CenteredGridItem>
			<FlexColumn gap="sm">
				<HeadingText>{stateRestriction.pageHeader}</HeadingText>
				<WYSIWYGContent dangerouslySetInnerHTML={{ __html: stateRestriction.pageInfo }} />
				{stateRestriction.showLearnMore && (
					<TextLink label={learnMoreText} href={stateRestriction.learnMoreHref} newTab />
				)}
			</FlexColumn>
		</CenteredGridItem>
	);
};

export default StateRestrictionStep;
